import { useTranslation } from 'react-i18next'

import { InputSection, LabelSize } from 'aem-libs-react-components/src/components/calculators/components/input-section'
import { PlusMinusNumberField } from 'aem-libs-react-components/src/components/forms/plus-minus-number-field'
import { PlusMinusSliderField } from 'aem-libs-react-components/src/components/forms/plus-minus-slider-field'
import { useDynamicParams } from 'aem-libs-react-ts/src/hooks/useDynamicParams'
import LanguageDetector from 'aem-libs-react-ts/src/services/LanguageDetector'

import { trackingKeys } from '../contants'
import { testIds } from '../e2e/testIds'
import { childrenSavingsStore } from '../store'
import type { ChildrenSavingsCalculatorParams } from '../types'


export const InputFields = () => {
  const { t } = useTranslation()

  const params = useDynamicParams<ChildrenSavingsCalculatorParams>()
  const values = childrenSavingsStore.useStoreData()
  const actions = childrenSavingsStore.useStoreActions()

  const tip = params.tip[LanguageDetector()]

  return (
    <InputSection.Container>
      <InputSection.Row
        id={trackingKeys.initialDeposit}
        label={t('INPUTS.INITIAL_AMOUNT')}
        labelSize={LabelSize.MEDIUM}
      >
        <PlusMinusSliderField
          id={trackingKeys.initialDeposit}
          unitType='czk'
          width='long'
          value={values.initialAmount}
          onChangeComplete={actions.setInitialAmount}
          trackingDescription={t('INPUTS.INITIAL_AMOUNT')}
          testId={testIds.initialDepositInputBase}
          responsive
          {...params.initialAmountConfig}
        />
      </InputSection.Row>
      <InputSection.Row
        id={trackingKeys.monthlyDepositId}
        label={t('INPUTS.MONTHLY_AMOUNT')}
        labelSize={LabelSize.MEDIUM}
      >
        <PlusMinusSliderField
          id={trackingKeys.monthlyDepositId}
          unitType='czk'
          width='long'
          value={values.monthlyAmount}
          onChangeComplete={actions.setMonthlyAmount}
          trackingDescription={t('INPUTS.MONTHLY_AMOUNT')}
          testId={testIds.monthlyDepositInputBase}
          responsive
          {...params.monthlyAmountConfig}
        />
      </InputSection.Row>
      <InputSection.Row id={trackingKeys.age} label={t('INPUTS.AGE')} labelSize={LabelSize.MEDIUM}>
        <PlusMinusNumberField
          id={trackingKeys.age}
          unitType='years'
          width='long'
          value={values.age}
          onChangeComplete={actions.setAge}
          trackingDescription={t('INPUTS.AGE')}
          testId={testIds.ageInputBase}
          responsive
          {...params.ageConfig}
        />
      </InputSection.Row>
      {tip && (
        <InputSection.Row>
          <InputSection.InfoBox
            infoPrefix={null}
            info={<div dangerouslySetInnerHTML={{ __html: params.tip[LanguageDetector()] }} />}
          ></InputSection.InfoBox>
        </InputSection.Row>
      )}
    </InputSection.Container>
  )
}
